import { put, takeLatest } from 'redux-saga/effects'
import { Action } from 'redux'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'

interface DetailAction extends Action {
    payload: any
}

const { onRequest, onSuccess, onFailure } = rootActions.quotations.close
function* closeQuotationsSaga({ payload }) {
    try {
        const response = yield axios.get(`/companies/quotations/revoke/${payload.id}`)
        if (response.success) {
            yield put(onSuccess({ data: response.result }))
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* closeQuotations(): any {
    yield takeLatest<DetailAction>(onRequest, closeQuotationsSaga)
}

export default closeQuotations
